import ModalTemplate from "../../../../src/components/ModalTemplate/ModalTemplate";
import Button from "../../../components/Button/Button";
import "./PublicModal.scss";
import classNames from "classnames";
import PublicDropzone from "../PublicDropzone/PublicDropzone";

const PublicModal = ({ uploadedFile, setUploadedFile, isOpen, onClose}) => {
    const footerButtons = (
        <>
            <Button
                type="submit"
                form="public-form"
                disabled={!uploadedFile}
                variant={classNames({"primary": uploadedFile, "disabled": !uploadedFile})}
            >
                Save
            </Button>
            <Button onClick={onClose} variant="secondary">
                Cancel
            </Button>
        </>
    );

    return (
        <ModalTemplate
            onClose={onClose}
            footerActions={footerButtons}
            className="delete public-header"
            footerClassName="public-footer"
        >
            <div className="public-modal">
                <PublicDropzone uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}/>
            </div>
        </ModalTemplate>
    );
};

export default PublicModal;